<template>
  <span v-if="worker.isLoaded.value">
    <button v-show="!!worker.workPauseStartDateTime.value" class="btn btn-sm btn-outline-danger" @click="endPauseAsync">Zaključi pavzo</button>
    <button v-show="!worker.workPauseStartDateTime.value && !!worker.id.value" class="btn btn-sm btn-outline-success" @click="pauseAsync">Pavza</button>
  </span>
</template>

<script setup>
import { useWorker } from "../composition-api/useWorker"
import { useAuth } from "../composition-api/useAuth"
import { changePauseAsync } from "../api"

defineOptions({ name: "Pause" })

const { worker, loadCurrentWorkerAsync } = useWorker()
const { fetchAuthAsync } = useAuth()

const pauseAsync = async () => {
  await changePauseAsync(fetchAuthAsync)
  await loadCurrentWorkerAsync(true)
}

const endPauseAsync = async () => {
  await changePauseAsync(fetchAuthAsync, true)
  await loadCurrentWorkerAsync(true)
}
</script>
